<template>
    <div v-if="!isMobileRealTime">
        <div class="display-flex-sb relative">
            <div
                class="picker-language__selection-wrapper team-competition-selected-wrapper"
                v-if="selected.selectedLangObj !== null"
                @mouseover="handleShowCompetitionOptionlist('enter')"
                @mouseleave="handleShowCompetitionOptionlist('leave')"
            >
                <div class="picker-language__selected-pill btn-aspn-default">
                    <div
                        class="picker-language__selected-name display-flex-align-center"
                    >
                        <template
                            v-if="selected?.selectedCompetitionObj?.leagueKey"
                        >
                            <Icon
                                :logoUrl="selected.selectedCompetitionObj.logo"
                                o
                                class="mr-05rem"
                            ></Icon>
                            {{ selected.selectedCompetitionObj.leagueName }}
                        </template>
                        <template v-else>
                            <IconMode>
                                <template #default="{ index }">
                                    <img
                                        src="@static/images/icons/aspn_icon/team/all_competition.png"
                                        v-if="
                                            [
                                                'lightWeb',
                                                'lightWebapp',
                                            ].includes(index)
                                        "
                                        class="mr-05rem all_competition_icon"
                                    />
                                    <img
                                        src="@static/images/icons/aspn_icon/team/all_competition_dark.png"
                                        v-else-if="
                                            ['darkWeb', 'darkWebapp'].includes(
                                                index
                                            )
                                        "
                                        class="mr-05rem all_competition_icon"
                                    />
                                </template>
                            </IconMode>
                            {{ $t("ALL_COMPETITIONS") }}
                        </template>
                    </div>
                    <div
                        class="picker-language__list-caret"
                        :class="{ active: selected.isShowList }"
                    >
                        <SvgIcon icon="c.header.newsCaret" />
                    </div>
                </div>
                <div
                    class="team-competition-list-wrapper picker-language-list__wrapper"
                    :class="{ active: selected.isShowList }"
                >
                    <NoData v-if="list.length === 0" />
                    <template v-else>
                        <div
                            class="picker-language-list__container"
                            v-for="(o, index) in list"
                            :key="index"
                            :class="{
                                selected:
                                    o.leagueKey ===
                                    selected.selectedCompetitionObj?.leagueKey,
                            }"
                            @click="handleCompetitionSelect(o)"
                        >
                            <div
                                class="picker-language-list__name display-flex-align-center"
                            >
                                <Icon
                                    :logoUrl="o?.logo"
                                    o
                                    class="mr-05rem"
                                    v-if="o.leagueKey !== null"
                                ></Icon>
                                <IconMode v-else>
                                    <template #default="{ index }">
                                        <img
                                            src="@static/images/icons/aspn_icon/team/all_competition.png"
                                            v-if="
                                                [
                                                    'lightWeb',
                                                    'lightWebapp',
                                                ].includes(index)
                                            "
                                            class="mr-05rem all_competition_icon"
                                        />
                                        <img
                                            src="@static/images/icons/aspn_icon/team/all_competition_dark.png"
                                            v-else-if="
                                                [
                                                    'darkWeb',
                                                    'darkWebapp',
                                                ].includes(index)
                                            "
                                            class="mr-05rem all_competition_icon"
                                        />
                                    </template>
                                </IconMode>
                                {{ o.leagueName }}
                            </div>
                            <SvgIcon
                                icon="c.team.tick"
                                v-if="
                                    o.leagueKey ===
                                    selected.selectedCompetitionObj?.leagueKey
                                "
                            ></SvgIcon>
                            <!-- <div class="picker-language-list__tick" :class="{ selected: o.leagueKey === selected.selectedCompetitionObj?.leagueKey }"></div> -->
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <slot name="mobileButton"></slot>

        <van-popup
            :show="show"
            destroy-on-close
            position="bottom"
            @close="onCancel"
        >
            <van-picker
                ref="pickerRef"
                :key="pickerKey"
                :title="$t(title)"
                :columns="list"
                @change="onChange"
                @cancel="onCancel"
                @confirm="onConfirm"
                :columns-field-names="columnsFieldNames"
                :confirm-button-text="$t(confirmButtonText)"
                :cancel-button-text="$t(cancelButtonText)"
                :default-index="selectedKey"
            >
                <template #option="option">
                    <div class="display-flex-align-center">
                        <slot
                            name="prefix"
                            :option="option"
                            v-if="content[0] !== ''"
                        >
                        </slot>

                        <template v-if="content[1] !== ''">
                            {{ option[content[1]] }}
                        </template>

                        <slot
                            name="suffix"
                            :option="option"
                            v-if="content[2] !== ''"
                        >
                        </slot>
                    </div>
                </template>
            </van-picker>
        </van-popup>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "Picker",
    props: {
        show: Boolean,
        list: Array,
        title: String,
        columnsFieldNames: Object,
        confirmButtonText: { type: String, default: "DONE" },
        cancelButtonText: { type: String, default: "CANCEL" },
        content: {
            type: Array,
            default: () => ["", "name", ""],
        },
        selected: Object,
    },
    data() {
        return {
            pickerKey: 0,
            selectedKey: 2,
        };
    },
    computed: {
        ...mapGetters(["isMobile", "isMobileRealTime"]),
    },
    methods: {
        onChange(option, index) {
            this.$emit("change", option, index);
        },
        onConfirm(option, index) {
            this.$emit("confirm", option, index);
        },
        onCancel(option, index) {
            this.$emit("cancel");
        },
        initIndex(index) {
            this.$nextTick(() => {
                this.selectedKey = this.selected.selectedIndex;
                this.pickerKey++;
            });
        },
        handleShowCompetitionOptionlist(action) {
            if (action === "enter") {
                this.selected.isShowList = true;
            } else {
                this.selected.isShowList = false;
            }
        },
        handleCompetitionSelect(o) {
            this.$emit("selected", o);
        },
    },
};
</script>

<style scoped>
.picker-language__selection-wrapper {
    position: relative;
    display: flex;
    border-radius: 16px;
    /* margin-top: 8px; */
    margin-bottom: 16px;
}
.picker-language__selected-pill {
    display: flex;
    justify-content: space-between;
    align-items: center;

    box-sizing: border-box;
    width: auto;
    border: 1px solid var(--color-border-default-default);
    border-radius: 1.5rem;
    padding: 8px 24px;
    font-size: 16px;
    font-family: var(--weight-600);
    cursor: pointer;
    letter-spacing: 0.64px;
}
.picker-language__selected-pill .picker-language__list-caret {
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
    transition: all 0.3s;
}
.picker-language__selected-pill .picker-language__list-caret.active {
    transform: rotateX(180deg);
}
.picker-language-list__wrapper {
    position: absolute;
    top: 105%;
    z-index: 2;
    background: var(--color-background-default-secondary);
    border-radius: 16px;
    min-width: 15.5rem;
    transform: scale(0);
    transform-origin: 50% 0;
    transition: all 0.3s;
    padding: 0.5rem;
    border: 1px solid var(--color-border-default-default);
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08),
        0px 0px 4px 0px rgba(0, 0, 0, 0.25),
        0px 0px 24px 0px rgba(0, 0, 0, 0.16);
}
.picker-language-list__wrapper.active {
    transform: scale(1);
}
.picker-language-list__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    margin-bottom: 0.375rem;
    border-radius: 8px;
    cursor: pointer;
}
.picker-language-list__container:last-child {
    margin-bottom: 0;
}
.picker-language-list__container:hover,
.picker-language-list__container.selected {
    background: var(--color-background-default-tertiary-hover);
}
.picker-language-list__container:hover .picker-language-list__name,
.picker-language-list__container.selected .picker-language-list__name {
    color: var(--color-text-default-default);
}

.picker-language-list__name {
    font-size: 16px;
    font-family: var(--weight-600);
}
.picker-language-list__tick {
    width: 1rem;
    height: 1rem;
}
.picker-language-list__tick.selected {
    background: url("../../../static/images/icons/icon_tick_selected.png")
        center/cover no-repeat;
    background-size: 12px 10px;
}
.all_competition_icon {
    width: 24px;
    height: 24px;
}
.nav-pill svg path {
    fill: var(--color-text-default-default);
}
.team-competition-selected-wrapper .picker-language__selected-pill {
    background-color: var(--color-background-default-secondary);
    border: 1px solid var(--color-border-default-default);
    color: var(--color-text-default-default);
}
.team-competition-list-wrapper .picker-language-list__name {
    color: var(--color-text-default-default);
}
.picker-language__selection-wrapper {
    margin-bottom: 0;
}
</style>

<style>
.van-picker__confirm {
    color: var(--color-text-primary-default) !important;
}
</style>
